














































import {
  computed,
  defineComponent,
  onMounted,
  PropType,
  ref
} from '@nuxtjs/composition-api';
import useWindowResize from '~/hooks/useResizeWindow';

type CardData = {
  id: number;
  number_of_columns: number;
  markdown_content: string;
  urls: {
    title: string;
    url: string;
    target: string;
    media_path: string;
    media_file_name: string;
    code_english: string;
  }[];
  media: {
    media_path: string;
    media_file_name: string;
  }[];
  custom_fields: {
    key: string;
    value_string: string;
  }[];
};

export default defineComponent({
  props: {
    data: {
      type: Object as PropType<CardData>,
      default: () => ({
        code: '',
        urls: [
          {
            title: '',
            url: '',
            media_path: '',
            media_file_name: '',
            code_english: ''
          }
        ],
        media: [
          {
            media_path: '',
            media_file_name: ''
          }
        ],
        custom_fields: [
          {
            key: '',
            value: ''
          }
        ]
      })
    }
  },
  setup(props) {
    const { isDesktop } = useWindowResize();
    const cardRef = ref(null);
    const cardWidth = ref(1);

    onMounted(() => {
      new ResizeObserver(() => {
        cardWidth.value = cardRef.value?.getBoundingClientRect().width || 1;
      }).observe(cardRef.value);
    });

    const linkData = computed(() => props.data.urls?.[0]);

    const media = computed(
      () =>
        props.data.media?.[0] || {
          media_path: '',
          media_file_name: ''
        }
    );

    const markdownContent = computed(() => {
      if (!props.data.markdown_content) {
        return { description: '', listItems: [] };
      }

      const markdownArr = props.data.markdown_content.split(' * ');

      return {
        description: markdownArr[0] || '',
        listItems: markdownArr.slice(1).filter(Boolean).map((item, index) => ({
          id: `${props.data.id}-item-${index}`,
          text: item
        }))
      };
    });

    const getField = (field: string) => {
      if (!props.data.custom_fields) return;
      return props.data.custom_fields.find(
        (customField) => customField.key === field
      )?.value_string;
    };

    const buttonText = computed(() => getField('button_text'));

    return {
      isDesktop,
      cardRef,
      cardWidth,
      linkData,
      media,
      buttonText,
      markdownContent,
      getField
    };
  }
});
